import { render, staticRenderFns } from "./DetailView.vue?vue&type=template&id=d911a00c&scoped=true"
import script from "./DetailView.vue?vue&type=script&lang=js"
export * from "./DetailView.vue?vue&type=script&lang=js"
import style0 from "./DetailView.vue?vue&type=style&index=0&id=d911a00c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d911a00c",
  null
  
)

export default component.exports